export const PurchaseSubscriptionMailAPI = async (email, name, premiumName, expiryDate) => {
    try {

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}send-purchase-subscription-mail`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                name: name,
                premiumName: premiumName,
                expiryDate: expiryDate
            })
        });

        if (!response.ok) {
            console.error(`Failed to send mail, status: ${response.status}`);
            return null;
        }

        // Attempt to parse JSON response
        const data = await response.json();

        console.log(data);
        

    } catch (error) {
        console.error("Error sending mail:", error);
        return null;
    }
};
